import { StaffRelatedWarehouses } from '@/services/Staff';

export type OperativeGroup = {
  id: string;
  alias: string;
  warehouses: {
    id: string,
    alias: string,
  }[];
};

export const groupWarehouses = (relatedWarehouses: StaffRelatedWarehouses[]): Record<string, OperativeGroup> => {
  const reducedList = relatedWarehouses.reduce((acc, warehouse) => {
    const { operativeAlias } = warehouse;
    const operativeId = warehouse.operativeId.toString();
    if (!(operativeId in acc)) {
      acc[operativeId] = {
        id: operativeId,
        alias: operativeAlias,
        warehouses: [],
      };
    }

    acc[operativeId].warehouses.push({
      id: warehouse.id,
      alias: warehouse.alias,
    });
    return acc;
  }, {} as Record<string, OperativeGroup>);

  return reducedList;
};

export default groupWarehouses;
